import Stack from '@mui/material/Stack';
import React from 'react';

export default function BrandedCertificateImage({ src, footerText, className }) {
    return (
        <div
            style={{
                position: 'relative',
                textAlign: 'center',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                width: '100%',
            }}
        >
            <img
                src={src}
                className={className}
                alt="image"
                style={{
                    maxWidth: '100%',
                    borderRadius: 12,
                    elevation: 3,
                    maxHeight: '100%',
                }}
            />
            {footerText && (
                <Stack
                    sx={{
                        backgroundColor: '#5124a6',
                        width: '100%',
                        boxSizing: 'border-box',
                    }}
                    borderRadius={2}
                    direction={'column'}
                    justifyContent={'space-around'}
                    alignItems={'center'}
                    spacing={2}
                    paddingY={2}
                    paddingX={1}
                >
                    <span style={{ color: 'white', fontSize: '12px', fontFamily: 'Poppins' }}>{footerText}</span>
                </Stack>
            )}
        </div>
    );
}
